import SectionWrapper from "./SectionWrapper";
import { MARKETPLACE } from "../../utils/constants";
import { Grid } from "@mui/material";
import CarrierSelect from "../forms/CarrierSelect";
import MerchantSelect from "../forms/MerchantSelect";
import { IAppliedEntitiesSectionProps } from "../../interfaces/configuration";

const AppliedEntitiesSection = ({
  entity,
  merchants,
  handleChangeValue,
  defaultValues,
  carriers,
}: IAppliedEntitiesSectionProps) => (
  <SectionWrapper title="Entidades aplicadas">
    {entity === MARKETPLACE && (
      <Grid item xs={6}>
        <MerchantSelect
          {...{
            merchants,
            handleChangeValue,
            initialValues: defaultValues,
          }}
        />
      </Grid>
    )}
    <Grid item xs={6}>
      <CarrierSelect
        {...{ carriers, handleChangeValue, initialValues: defaultValues }}
      />
    </Grid>
  </SectionWrapper>
);

export default AppliedEntitiesSection;
